/**
 * API client — axios wrapper that always sends the session cookie and the
 * CSRF header on state-changing requests. The CSRF token is stored in module
 * memory only (never localStorage / never a cookie / never URL).
 */
import axios from "axios";

const BASE = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

let csrfToken = null;
export const setCsrfToken = (t) => { csrfToken = t || null; };
export const getCsrfToken = () => csrfToken;

export const api = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method) && csrfToken) {
    config.headers = config.headers || {};
    config.headers["X-CSRF-Token"] = csrfToken;
  }
  return config;
});

export const parseErrorDetail = (err) => {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  return "Something went wrong. Please try again.";
};
